<div class="row clearfix" *ngIf="show">
    <hr>
    <div class="col-sm-2">
        <div class="form-group">

            <mat-form-field appearance="outline" class="example-full-width">
                <mat-label> Batch</mat-label>
                <input readonly matInput formControlName="Batch" placeholder="">
            </mat-form-field>

        </div>
    </div>

    <div class="col-sm-4">
        <div class="form-group">

            <mat-form-field appearance="outline" class="example-full-width">
                <mat-label> Name</mat-label>
                <input matInput formControlName="Name" required placeholder="">
                <mat-error class="margin_tp"
                        *ngIf="registrationForm.controls['Name'].touched && registrationForm.controls['Name'].errors?.required">
                        This Field Is Mandatory.
                </mat-error>
            </mat-form-field>

        </div>
    </div>
    <div class="col-sm-3">
        <div class="form-group">

            <mat-form-field appearance="outline" class="example-full-width">
                <mat-label> Registration Number</mat-label>
                <input matInput formControlName="RgNo" maxlength="8"
                    placeholder="Registration Number">
            </mat-form-field>

        </div>
    </div>
    <div class="col-sm-3">
        <div class="form-group">

            <mat-form-field appearance="outline" class="example-full-width">
                <mat-label> Form Number</mat-label>
                <input matInput formControlName="FormNo" placeholder="Form Number">
            </mat-form-field>

        </div>
    </div>
    <div class="col-sm-2">
        <div class="form-group">

            <!-- <mat-form-field appearance="outline" class="example-full-width">
                <mat-label>College</mat-label>
                <input matInput formControlName="CgCode" required placeholder="College Code">
                <mat-error class="margin_tp"
                        *ngIf="registrationForm.controls['CgCode'].touched && registrationForm.controls['CgCode'].errors?.required">
                        This Field Is Mandatory.
                </mat-error>
            </mat-form-field> -->
            <mat-form-field appearance="outline" class="example-full-width" >
                <mat-label> College</mat-label>
                <mat-select  required #select22 placeholder="College Name" class="colorblack"
                    formControlName="CgCode">
                    <mat-select-filter *ngIf="select22.focused" [placeholder]="'College Name'"
                        [displayMember]="'CgName'" [array]="courseClgMapList"
                        (filteredReturn)="filteredstucourseClgMapListList =$event">
                    </mat-select-filter>
                    <mat-option *ngFor="let item of filteredstucourseClgMapListList" [value]="item.CgCode">
                        {{item.CgCode}} - {{item.CgName}}
                    </mat-option>
                </mat-select>
                <mat-error class="margin_tp"
                        *ngIf="registrationForm.controls['CgCode'].touched && registrationForm.controls['CgCode'].errors?.required">
                        This Field Is Mandatory.
                </mat-error>
            </mat-form-field>
        </div>
    </div>
    <div class="col-sm-4">
        <div class="form-group">

            <mat-form-field appearance="outline" class="example-full-width">
                <mat-label> Father Name</mat-label>
                <input matInput formControlName="Father" placeholder="Father Name">
                
            </mat-form-field>

        </div>
    </div>
    <div class="col-sm-3">
        <div class="form-group">

            <mat-form-field appearance="outline" class="example-full-width">
                <mat-label> Mother Name</mat-label>
                <input matInput formControlName="Mother" placeholder="Mother Name">
            </mat-form-field>

        </div>
    </div>
    <div class="col-sm-3">
        <div class="form-group">

            <mat-form-field appearance="outline" class="example-full-width">
                <mat-label> Date Of Birth</mat-label>
                <input required matInput [matDatepicker]="dob" id="dob"
                    formControlName="BirthDate" maxlength="10"
                    placeholder="DD/MM/YYYY"  [min]="minDate" [max]="currentdate" >
                <mat-datepicker-toggle matSuffix [for]="dob">
                </mat-datepicker-toggle>
                <mat-datepicker #dob></mat-datepicker>
                <mat-error class="margin_tp"
                *ngIf="registrationForm.controls['BirthDate'].touched && registrationForm.controls['BirthDate'].errors?.required">
                This Field Is Mandatory.
        </mat-error>
            </mat-form-field>

        </div>
    </div>

    <div class="col-sm-3">
        <div class="form-group">

            <mat-form-field appearance="outline" class="example-full-width">
                <mat-label> Gender</mat-label>
                <!-- <input matInput formControlName="CSExBr" placeholder="" > -->
                <mat-select #select23 placeholder="" class="colorblack"
                    formControlName="Sex">
                    <mat-select-filter *ngIf="select23.focused"
                        [placeholder]="'Filter'" [displayMember]="'CdDesc'"
                        [array]="genderList"
                        (filteredReturn)="filteredGenderList =$event">
                    </mat-select-filter>
                    <mat-option *ngFor="let item of filteredGenderList"
                        [value]="item.CdCode">
                        {{item.CdDesc}}
                    </mat-option>
                </mat-select>
            </mat-form-field>

        </div>
    </div>

    <div class="col-sm-3">
        <div class="form-group">

            <mat-form-field appearance="outline" class="example-full-width">
                <mat-label> Category</mat-label>
                <!-- <input matInput formControlName="CSExBr" placeholder="" > -->
                <mat-select #select24 placeholder="" class="colorblack"
                    formControlName="Cate">
                    <mat-select-filter *ngIf="select24.focused"
                        [placeholder]="'Filter'" [displayMember]="'CdDesc'"
                        [array]="ConstiCateList"
                        (filteredReturn)="filteredConstiCateList =$event">
                    </mat-select-filter>
                    <mat-option *ngFor="let item of filteredConstiCateList"
                        [value]="item.CdCode">
                        {{item.CdDesc}}
                    </mat-option>
                </mat-select>
            </mat-form-field>

        </div>
    </div>

    <div class="col-sm-3">
        <div class="form-group">

            <mat-form-field appearance="outline" class="example-full-width">
                <mat-label> Caste</mat-label>
                <!-- <input matInput formControlName="CSExBr" placeholder="" > -->
                <mat-select #select25 placeholder="" class="colorblack"
                    formControlName="Caste">
                    <mat-select-filter *ngIf="select25.focused"
                        [placeholder]="'Filter'" [displayMember]="'CdDesc'"
                        [array]="categoryList"
                        (filteredReturn)="filteredCategoryList =$event">
                    </mat-select-filter>
                    <mat-option *ngFor="let item of filteredCategoryList"
                        [value]="item.CdCode">
                        {{item.CdDesc}}
                    </mat-option>
                </mat-select>
            </mat-form-field>

        </div>
    </div>

    <div class="col-sm-3">
        <div class="form-group">

            <mat-form-field appearance="outline" class="example-full-width">
                <mat-label> Email</mat-label>
                <input matInput formControlName="EMail" placeholder="">

            </mat-form-field>

        </div>
    </div>
    <div class="col-sm-3">
        <div class="form-group">

            <mat-form-field appearance="outline" class="example-full-width">
                <mat-label> Medium</mat-label>
                <!-- <input matInput formControlName="CSExBr" placeholder="" > -->
                <mat-select #select26 placeholder="" class="colorblack"
                    formControlName="Medium">
                    <mat-select-filter *ngIf="select26.focused"
                        [placeholder]="'Filter'" [displayMember]="'CdDesc'"
                        [array]="ListOfMedium"
                        (filteredReturn)="filteredListOfMedium =$event">
                    </mat-select-filter>
                    <mat-option *ngFor="let item of filteredListOfMedium"
                        [value]="item.CdCode">
                        {{item.CdDesc}}
                    </mat-option>
                </mat-select>
            </mat-form-field>

        </div>
    </div>
    <div class="col-sm-3">
        <div class="form-group">

            <mat-form-field appearance="outline" class="example-full-width">
                <mat-label> Nationality</mat-label>
                <!-- <input matInput formControlName="CSExBr" placeholder="" > -->
                <mat-select #select27 placeholder="" class="colorblack"
                    formControlName="Nation">
                    <mat-select-filter *ngIf="select27.focused"
                        [placeholder]="'Filter'" [displayMember]="'CdDesc'"
                        [array]="nationalityList"
                        (filteredReturn)="filteredNationalityList =$event">
                    </mat-select-filter>
                    <mat-option *ngFor="let item of filteredNationalityList"
                        [value]="item.CdCode">
                        {{item.CdDesc}}
                    </mat-option>
                </mat-select>
            </mat-form-field>

        </div>
    </div>
    <div class="col-sm-3">
        <div class="form-group">

            <mat-form-field appearance="outline" class="example-full-width">
                <mat-label> Mobile</mat-label>
                <input matInput formControlName="Mobile" maxlength="10"
                    placeholder="">

            </mat-form-field>

        </div>
    </div>
    <div class="col-sm-1">
        <div class="form-group">

            <mat-form-field appearance="outline" class="example-full-width">
                <mat-label> First Exam(New Student)</mat-label>
                <input matTooltip="First Exam(New Student)" matInput formControlName="EmSrNoF" maxlength="" placeholder="fexam">
            </mat-form-field>

        </div>
    </div>
    <div class="col-sm-2">
        <div class="form-group">

            <mat-form-field appearance="outline" class="example-full-width">
                 <mat-select #select223 placeholder="" class="colorblack"
                    formControlName="EmSkip">
                    <mat-select-filter *ngIf="select223.focused"
                        [placeholder]="'Filter'" [displayMember]="'CdDesc'"
                        [array]="ListOfExamSkipReason"
                        (filteredReturn)="filteredListOfExamSkipReason =$event">
                    </mat-select-filter>
                    <mat-option *ngFor="let item of filteredListOfExamSkipReason"
                        [value]="item.CdCode">
                        {{item.CdDesc}}
                    </mat-option>
                </mat-select>
            </mat-form-field>

        </div>
    </div>
    <div class="col-sm-3" *ngIf="Branches">
        <div class="form-group">
            <mat-form-field appearance="outline" class="example-full-width">
                <mat-label> Branches</mat-label>
                <mat-select #select28 placeholder="" class="colorblack"
                    formControlName="StrCode">
                    <mat-select-filter *ngIf="select28.focused"
                        [placeholder]="'Filter'" [displayMember]="'StrName'"
                        [array]="streamList"
                        (filteredReturn)="filteredStreamList =$event">
                    </mat-select-filter>
                    <mat-option *ngFor="let item of filteredStreamList"
                        [value]="item.StrId" (click)="getSub(item.StrId)">
                        {{item.StrName}}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>
    </div>
    <div class="col-sm-4">
        <div class="form-group">
            <mat-form-field appearance="outline" class="example-full-width">
                <mat-label> Subject Combo</mat-label>
                <mat-select multiple #select29 placeholder="" class="colorblack"
                    formControlName="Sub">
                    <mat-select-filter *ngIf="select29.focused"
                        [placeholder]="'Filter'" [displayMember]="'EsName'"
                        [array]="subjectList"
                        (filteredReturn)="filteredSubjectList =$event">
                    </mat-select-filter>
                    <mat-option *ngFor="let item of filteredSubjectList"
                        [value]="item.EsCode">
                        {{item.EsName}}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>
    </div>
    <div class="col-sm-4">
        <div class="form-group">
            <mat-form-field appearance="outline" class="example-full-width">
                <mat-label>Address </mat-label>
                <input matInput formControlName="Addr1" maxlength="10"
                    placeholder="">
            </mat-form-field>
        </div>
    </div>
    <div class="col-sm-4">
        <div class="form-group">

            <mat-form-field appearance="outline" class="example-full-width">
                <mat-label>Permanent Address </mat-label>
                <input matInput formControlName="Addr1P" maxlength="10"
                    placeholder="">
            </mat-form-field>

        </div>
    </div>

    <div class="col-sm-4">
        <div class="form-group">

            <mat-form-field appearance="outline" class="example-full-width">
                <mat-label> Subject</mat-label>
                <input matInput formControlName="ExSub" maxlength="10"
                    placeholder="">

            </mat-form-field>

        </div>
    </div>
    <div class="col-sm-4">
        <div class="form-group">

            <mat-form-field appearance="outline" class="example-full-width">
                <mat-label> </mat-label>
                <input matInput formControlName="Addr2" maxlength="10"
                    placeholder="">

            </mat-form-field>

        </div>
    </div>
    <div class="col-sm-4">
        <div class="form-group">

            <mat-form-field appearance="outline" class="example-full-width">
                <mat-label> </mat-label>
                <input matInput formControlName="Addr2P" maxlength="10"
                    placeholder="">

            </mat-form-field>

        </div>
    </div>
    <div class="col-sm-4">

    </div>
    <div class="col-sm-4">
        <div class="form-group">

            <mat-form-field appearance="outline" class="example-full-width">
                <mat-label> </mat-label>
                <input matInput formControlName="Addr3" maxlength="10"
                    placeholder="">

            </mat-form-field>

        </div>
    </div>
    <div class="col-sm-4">
        <div class="form-group">

            <mat-form-field appearance="outline" class="example-full-width">
                <mat-label> </mat-label>
                <input matInput formControlName="Addr3P" maxlength="10"
                    placeholder="">

            </mat-form-field>

        </div>
    </div>

    <div class="col-sm-1">
        <div class="form-group">

            <!-- <mat-form-field appearance="outline" class="example-full-width">
                <mat-label> Valid</mat-label>
                <input matInput formControlName="valid" maxlength="10"
                    placeholder="">

            </mat-form-field> -->
            <mat-form-field appearance="outline" class="example-full-width">
                <mat-label> Valid</mat-label>
                <mat-select formControlName="valid" #select104
                    class="colorblack">
                    <!-- <mat-option>Select</mat-option> -->
                    <mat-option value="N">No</mat-option>
                    <mat-option value="Y">Yes</mat-option>
                </mat-select>
            </mat-form-field>

        </div>
    </div>
    <div class="col-sm-3">
        <div class="form-group">

            <mat-form-field appearance="outline" class="example-full-width">
                <mat-label> </mat-label>
                <input matInput formControlName="msg" maxlength="60"
                    placeholder="">

            </mat-form-field>

        </div>
    </div>
    <div class="col-sm-2">
        <div class="form-group">

            <mat-form-field appearance="outline" class="example-full-width">
                <mat-label> Place</mat-label>
                <input matInput formControlName="Place" maxlength="10"
                    placeholder="Place">

            </mat-form-field>

        </div>
    </div>
    <div class="col-sm-2">
        <div class="form-group">

            <mat-form-field appearance="outline" class="example-full-width">
                <mat-label> Pin Code</mat-label>
                <input matInput formControlName="Pin" maxlength=""
                    placeholder="Pin">

            </mat-form-field>

        </div>
    </div>
    <div class="col-sm-2">
        <div class="form-group">

            <mat-form-field appearance="outline" class="example-full-width">
                <mat-label>Permanent Place</mat-label>
                <input matInput formControlName="PlaceP" maxlength="10"
                    placeholder="PlaceP">

            </mat-form-field>

        </div>
    </div>
    <div class="col-sm-2">
        <div class="form-group">

            <mat-form-field appearance="outline" appearance="outline"
                class="example-full-width">
                <mat-label>Permanent Pin Code </mat-label>
                <input matInput formControlName="PinP" maxlength="10"
                    placeholder="PinP">

            </mat-form-field>

        </div>
    </div>
    <div class="col-sm-12">
        <button type="button" *ngIf="submitbutton" 
            class="btn btn-primary my-2 me-2 mt-0 btn-icon-text floatright btn-raised g-bg-blush2"
            (click)="addRegFormData()">Submit</button>
         <button type="button"
                class="btn btn-primary my-2 me-2 btn-icon-text floatright btn-raised g-bg-blush2"
                *ngIf="updatebutton" (click)="update()">Update</button> 
        <!-- <button type="button"
                class="btn btn-primary my-2 me-2 btn-icon-text floatright btn-raised g-bg-blush2"
                *ngIf="deleteButton" (click)="DeletetheRecord()">Delete</button> -->
    </div>
   


</div>
